import { render } from "./IndexErrorDialog.vue?vue&type=template&id=6798e256"
import script from "./IndexErrorDialog.vue?vue&type=script&lang=js"
export * from "./IndexErrorDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IndexErrorDialog.vue"]])

export default __exports__